var _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 80,
    viewBox: "0 0 51 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7943 79.9399C12.8069 78.9026 2.61423 67.1876 3.92941 54.1393C4.2563 50.586 5.3201 47.1399 7.05297 44.0206C14.4196 30.8392 22.9996 23.4035 27.657 3.81054C26.5933 14.0887 29.3552 25.4913 34.5107 34.3885C38.7752 41.7503 40.2811 29.2067 38.7686 25.2875C53.1435 39.3008 42.4347 67.8123 21.9326 60.005C28.9097 56.8486 31.1389 47.0061 23.695 39.3665C21.0646 46.1397 15.194 51.767 14.6909 59.2587C14.6777 67.3931 22.1447 73.7125 29.8796 74.3192C37.1246 75.1642 43.8534 73.2045 49.992 69.425C50.0299 69.4037 50.0759 69.3971 50.2107 69.4908C43.3208 75.8283 35.4247 80.2802 25.7943 79.9399Z",
    fill: "#F2A66F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7943 79.9399C12.8069 78.9026 2.61423 67.1876 3.92941 54.1393C4.2563 50.586 5.3201 47.1399 7.05297 44.0206C14.4196 30.8392 22.9996 23.4035 27.657 3.81054C26.5933 14.0887 29.3552 25.4913 34.5107 34.3885C38.7752 41.7503 40.2811 29.2067 38.7686 25.2875C53.1435 39.3008 42.4347 67.8123 21.9326 60.005C28.9097 56.8486 31.1389 47.0061 23.695 39.3665C21.0646 46.1397 15.194 51.767 14.6909 59.2587C14.6777 67.3931 22.1447 73.7125 29.8796 74.3192C37.1246 75.1642 43.8534 73.2045 49.992 69.425C50.0299 69.4037 50.0759 69.3971 50.2107 69.4908C43.3208 75.8283 35.4247 80.2802 25.7943 79.9399Z",
    fill: "url(#paint0_linear_797_1307)",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.674 0C22.7266 15.991 15.1478 24.3309 7.4014 37.0651C4.8345 41.3886 2.99715 46.1052 1.96312 51.0258C1.91845 51.2806 1.80473 51.5183 1.63432 51.713C-0.52258 43.0196 1.16414 33.958 6.41501 26.6834C11.6248 19.0307 18.2517 12.1852 21.5396 3.37838C21.9473 2.26376 22.2975 1.12613 22.674 0Z",
    fill: "#F2A66F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.674 0C22.7266 15.991 15.1478 24.3309 7.4014 37.0651C4.8345 41.3886 2.99715 46.1052 1.96312 51.0258C1.91845 51.2806 1.80473 51.5183 1.63432 51.713C-0.52258 43.0196 1.16414 33.958 6.41501 26.6834C11.6248 19.0307 18.2517 12.1852 21.5396 3.37838C21.9473 2.26376 22.2975 1.12613 22.674 0Z",
    fill: "url(#paint1_linear_797_1307)",
    fillOpacity: 0.8
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_797_1307",
    x1: 2.2446,
    y1: 18.1433,
    x2: 25.7653,
    y2: 59.1579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD699"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE0B1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_797_1307",
    x1: -0.0228247,
    y1: 9.73357,
    x2: 18.1386,
    y2: 31.7999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD699"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE0B1",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f83376487f312e152ba10af2f431151c.svg";
export { ForwardRef as ReactComponent };